import { render } from "./VerticalImg.vue?vue&type=template&id=79d0c9ee&scoped=true"
import script from "./VerticalImg.vue?vue&type=script&lang=js"
export * from "./VerticalImg.vue?vue&type=script&lang=js"

import "./VerticalImg.vue?vue&type=style&index=0&id=79d0c9ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79d0c9ee"

export default script